export default function(e){return String(e).replace(/[^\d]/g,"")};
//# sourceMappingURL=index.m.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@brazilian-utils/helper-only-numbers/dist/index.m.js
// module id = 70
// module chunks = 0